import { ActionPermissionsObject, PermissionActionType } from "common/interfaces";
import WorkspaceController, { WorkspaceControllerState } from "js/controllers/WorkspaceController";
import React from "react";
import styled, { css } from "styled-components";

import { Breadcrumb } from "js/Components/Breadcrumb";

/** Outer row: breadcrumb track + toolbar action (e.g. New Slide / New Template). */
const SearchBarHeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: end;
`;

const breadcrumbCrumbShared = css`
    color: #666;
    font-family: "Source Sans Pro", sans-serif;
    font-size: 18px;
    font-style: normal;
    line-height: 125%;
    text-transform: none;
`;

/** Breadcrumb segment (e.g. library title). */
export const TeamLibrarySearchBarCrumbEmphasis = styled.span`
    ${breadcrumbCrumbShared}
    text-transform: capitalize;
    color: #444;
    font-weight: 600;
`;

/** Vertical bar between breadcrumb segments; stretches with flex text height. */
export const TeamLibrarySearchBarBreadcrumbDivider = styled.div`
    width: 1px;
    flex-shrink: 0;
    align-self: stretch;
    min-height: 1em;
    margin-left: 15px;
    margin-right: 15px;
    background: #999;
`;

function Header(props: WorkspaceControllerState & {
    children?: React.ReactNode;
}) {
    const { children } = props;

    if (!children) {
        return null;
    }

    return (
        <SearchBarHeaderRow>
            {children}
        </SearchBarHeaderRow>
    );
}

export default WorkspaceController.withState(Header);
